import { useIsLoggedIn } from '#shared/composables/useIsLoggedIn';
import { useRoutes } from '#shared/lib/routes';
import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app';

export default defineNuxtRouteMiddleware(() => {
  const isLoggedIn = useIsLoggedIn();
  const { getUrl } = useRoutes();
  if (!isLoggedIn.value)
    return navigateTo(getUrl('clientHome', { authenticate: true }), {
      external: true,
    });
});
